import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, switchMap, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { LoginRequest } from './models/login-request.model';
import { SessionService } from './session.service';
import { User } from './models/user.model';
import { BettingSettingsService } from './betting-settings.service';

@Injectable({ providedIn: 'root' })
export class LoginService {

  private http: HttpClient = inject(HttpClient);
  private session: SessionService = inject(SessionService);
  private bettingSettings = inject(BettingSettingsService);

  login(request: LoginRequest): Observable<User> {
    const body = new URLSearchParams();
    body.set('AccountNr', request.AccountNr);
    body.set('Password', request.Password);

    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );

    return this.http
      .post(`${environment.apiUrl}/Account/MobileLogin`, body.toString(), {
        headers,
        responseType: 'text',
        withCredentials: true
      })
      .pipe(switchMap(() => this.fetchCurrentUser()));
  }

  fetchCurrentUser(): Observable<User> {
    return this.http
      .get<User>(`${environment.apiUrl}/Api/UserAccountSettings`, { withCredentials: true })
      .pipe(tap(user => {
        this.session.setUser(user);
        this.bettingSettings.loadSettings();
      }));
  }
}
